import dayjs from "dayjs";

type DateFormatter = (date : dayjs.ConfigType) => string;

export function useDateFormat() : DateFormatter {
    return (date: dayjs.ConfigType): string => {
        if (date === undefined) {
            return ""
        }
        return dayjs(date).format("YYYY-MM-DD HH:mm")
    }
}
